import { EntityActionsProps } from './EntityActions';
import { Box, Stack, Typography } from '@mui/material';
import { CloudOnIcon } from '../../../../../../assets';
import useDeviceStatusFromGroup from '../../../../../../service/device/CommanderAPI/hooks/useDeviceStatusFromGroup';
import { M_SECONDS_POOLING_INTERVAL_DATA } from '../../../../../../service/store/Store.constants';
import { fromBase64 } from '../../../../../../shared/util/base64';
import { memo } from 'react';

export function EntityCommanderStatusAction(props: EntityActionsProps) {
  const { entity, active } = props;
  const groupId = fromBase64(entity?.id ?? '');
  const {
    numberFailingMqttConnection,
    isLoading: isLoadingDeviceStatus,
    commanderIdsDevices,
  } = useDeviceStatusFromGroup(groupId, {
    pollingInterval: M_SECONDS_POOLING_INTERVAL_DATA,
  });

  const loading = isLoadingDeviceStatus;
  const numberStoresOK =
    (commanderIdsDevices?.length ?? 0) - (numberFailingMqttConnection ?? 0);
  if (!loading && !commanderIdsDevices.length) return null;

  const storesOk = numberStoresOK ? (
    <Box
      sx={{
        fontSize: '1rem',
        width: '6rem',
        height: '3rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Stack direction={'row'} spacing={0.5}>
        <Typography
          component="span"
          variant={'inherit'}
          color={!active ? 'success' : 'inherit'}
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <CloudOnIcon height={'1.5em'} />
        </Typography>
        <Typography
          component="span"
          variant={'inherit'}
          fontSize={'1rem'}
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
          color={'text.primary'}
        >
          |
        </Typography>
        <Typography
          component="span"
          variant={'inherit'}
          display={'flex'}
          alignItems={'center'}
          fontSize={'1rem'}
          justifyContent={'center'}
          color={'text.primary'}
        >
          {numberStoresOK}
        </Typography>
      </Stack>
    </Box>
  ) : null;

  return storesOk;
}

export default memo(EntityCommanderStatusAction);
